import { m8API } from 'services/production/m8';
import { CheckAuthorisationPhoneCodeService } from 'types/services';

export const checkAuthorisationPhoneCode: CheckAuthorisationPhoneCodeService = async (
  params
) => {
  const { phone, code } = params;

  await m8API.auth.checkAuthorisationPhoneCode({ phone, code });
};
